import type { ContentCardVariant } from './types';

export interface ContentCardStyleOption {
  value: ContentCardVariant;
  label: string;
  description: string;
}

export const CONTENT_CARD_STYLE_OPTIONS: ContentCardStyleOption[] = [
  {
    value: 'minimal',
    label: 'Minimal',
    description: 'İnce çerçeve, yumuşak gölge ve sade tipografi'
  },
  {
    value: 'emoji',
    label: 'Emoji Kart',
    description: 'İkon + başlık ve kısa açıklama (ikon boyutu minimal kart ile aynı)'
  },
  {
    value: 'values-strip',
    label: 'Değerler Şeridi',
    description: 'Yapışık cam şerit; site renginde ikonlar, dikey ayırıcılar'
  },
  {
    value: 'feature-split',
    label: 'Özellik + Görsel',
    description: 'Başlık, yeşil tik maddeleri ve sağa/sola alınabilir büyük görsel'
  },
  {
    value: 'editorial-fade',
    label: 'Metin + Görsel',
    description: 'Solda etiket, başlık, metin ve buton; sağda beyaza karışan fotoğraf'
  },
  {
    value: 'offer-split',
    label: 'Fırsat Kartı',
    description: 'Görselin yanında başlık, fiyat ve isteğe bağlı geri sayım'
  },
  {
    value: 'pricing-trio',
    label: "3'lü Fiyat Paketi",
    description: 'İsim, açıklama, fiyat ve özellikler — ortadaki paket öne çıkar'
  },
  {
    value: 'pricing-scroll',
    label: 'Scroll Fiyat Kartı',
    description: 'İki fiyat kartı; kaydırılabilir özellik listesi ve CTA butonu'
  },
  {
    value: 'banner',
    label: 'Kampanya Banner',
    description: 'Sol görsel + sağ renkli panel — sade indirim / sezon kartı'
  },
  {
    value: 'image-tile',
    label: 'Görsel Kart',
    description: 'Tam görsel + üstünde başlık; kategoriye veya URL’ye tıklanır'
  },
  {
    value: 'feature-grid',
    label: 'Özellik Izgarası',
    description: 'Koyu zeminli tam genişlik bölüm; ikon + başlık + açıklama kartları'
  },
  {
    value: 'comparison-table',
    label: 'Kıyaslama Tablosu',
    description: 'Üç sütunlu karşılaştırma. Sayfa ve konum içerik kartlarından seçilir.'
  },
  {
    value: 'process-steps',
    label: 'Sayılı Adımlar',
    description: 'Numaralı süreç kartları. Sayfa ve konum içerik kartlarından seçilir.'
  }
];

const CONTENT_CARD_VARIANTS: ContentCardVariant[] = [
  'emoji',
  'minimal',
  'banner',
  'image-tile',
  'feature-split',
  'editorial-fade',
  'offer-split',
  'pricing-trio',
  'pricing-scroll',
  'values-strip',
  'feature-grid',
  'comparison-table',
  'process-steps'
];

export const normalizeContentCardVariant = (value: unknown): ContentCardVariant => {
  const raw = String(value || '').trim() as ContentCardVariant;
  if (CONTENT_CARD_VARIANTS.includes(raw)) return raw;
  return 'minimal';
};
